export default __webpack_public_path__ + "static/media/arrow_forward_ios.6836344a.svg";